<script>
import Layout from "../../../layouts/print";
import appConfig from "@/app.config";
import { itemtransactionService } from "../../../../services/inventoryservice/itemtransaction.service";
import moment from 'moment'
/* eslint-disable no-console */
export default {
  page: {
    title: "Invoice",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
     invoice: {},
     invoiceItem: []
    };
  },
  mounted() {
    this.loadingData(this.$route.params.id);
    
  },
  methods: {
    
    loadingData: function(param = '') {
      this.fetchingStats = false;
      itemtransactionService.invoice(param)
        .then(response => {
          this.fetchingStats = true;
          this.invoice = response.data.invoice;
          this.invoiceItem = response.data.invoice_items;
          console.log(response);
        });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = '.0000';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
  },

  computed: {
    totalPrice() {
      return this.invoiceItem.reduce(function (sum, item) {
        return sum + (item.quantity * item.price)
      }, 0)
    }
  }
};

</script>

<template>
  <Layout>
    
        <center>
          <div class="col dblack box-a4-long">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="14%"><p>&nbsp;</p></td>
                <td width="86%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khm h6">លំនៅឋាន អេចស៊ី ឯ.ក</p>
                  <p class="enb h6">LOMNOV THAN HC CO., LTD</p>
                  <p class="khs h7">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h7">ទូរស័ព្ទលេខៈ 078 554 077 | 015 554 077 Email: account@h-residence.net</p>
                </td>
              </tr>
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <br/>
            <table width="100%" class="content-general"><tr><td class="center">
              <p class="h5 khm">វិក្ក័យបត្រ</p>
              
            </td></tr></table>
            <br>

            <table class="content-general h6 left">
              
              <tr>
                <td style="width:3cm"><p class="khs">លេខវិក្ក័យបត្រ</p></td>
                <td style="width:14cm"><p class="khs">៖ {{invoice.number}}</p></td>
                <td style="width:3cm" colspan="2"><p class="khs">ថ្ងៃទី {{dateFormat(invoice.transaction_date)}}</p></td>
              </tr>
              <tr>
                <td><p class="khs">ឈ្មោះអ្នកផ្គត់ផ្គង់</p></td>
                <td><p class="khs">៖ {{invoice.supplier_name}}</p></td>
                <td><p class="khs">ប្រភេទ</p></td>
                <td><p class="khs">៖ {{invoice.type_name}}</p></td>
              </tr>
              <tr>
                <td><p class="khs">លេខយោង</p></td>
                <td><p class="khs">៖ {{invoice.reference}}</p></td>
                <td><p class="khs">ស្ថានភាព</p></td>
                <td><p class="khs" style="width:3cm">៖ {{invoice.status_name}}</p></td>
              </tr>
            </table>
            <br>
            <table class="content-general h6 schedule-table" width="100%">
              
                <tr class="thead">
                  <td><p class="khs">ល.រ</p></td>
                  <td><p class="khs text-align-left">ឈ្មោះ</p></td>
                  <td><p class="khs text-align-left">ចំនួន</p></td>
                  <td><p class="khs text-align-left">តម្លៃរាយ</p></td>
                  <td><p class="khs text-align-left">តម្លៃសរុប</p></td>
                </tr>
             
              <tbody>
                 <tr v-for="(data, index) in invoiceItem" :key="index" >
                   <td>{{index + 1}}</td>
                   <td class="text-align-left">{{data.name}}</td>
                   <td class="text-align-left">{{data.quantity}}</td>
                   <td class="text-align-left">{{formatCurrency(data.price)}}</td>
                   <td class="text-align-left">{{formatCurrency(data.price * data.quantity)}}</td>
                </tr>
              </tbody>
              
                <tr class="tfoot">
                  <td colspan="4" class="text-align-right">សរុប៖</td>
                  <td class="text-align-left">{{formatCurrency(totalPrice)}}</td>
                </tr>
              
            </table>
            <br>
            <table class="content-general h6 center" width="100%">
              <tr>
                <td>
                  <p class="khs">ពិនិត្យដោយ</p>
                  <p class="khs">ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs">. . . . . . . . . . . . . . . . . . . .</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . . .</p>
                </td>
                <td>
                  <p class="khs">ពិនិត្យដោយ</p>
                  <p class="khs">ប្រធានគណនេយ្យ</p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs">. . . . . . . . . . . . . . . . . . . .</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . . .</p>
                </td>
                <td>
                  <p class="khs">ពិនិត្យដោយ</p>
                  <p class="khs">ផ្នែកគណនេយ្យ</p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs">លី រដ្ឋា</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . . .</p>
                </td>
              </tr>
              <tr><td colspan="3"><hr></td></tr>
              <tr>
                <td>
                  <p class="khs">អនុម័តដោយ</p>
                  <p class="khs">នាយកក្រុមហ៊ុន</p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs">លី ប៊ុនហ៊ាង</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . . .</p>
                </td>
                <td>
                  <p class="khs">អនុម័តដោយ</p>
                  <p class="khs">នាយកហិរញ្ញវត្ថុ</p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs">លីម ទ្រី</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . . .</p>
                </td>
                <td>
                  <p class="khs">អនុម័តដោយ</p>
                  <p class="khs">នាយកបច្ចេកទេស</p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs">សាយនី យូស៊ន់</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . . .</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>